import { render, staticRenderFns } from "./companyCheck3.vue?vue&type=template&id=b2eb1054&scoped=true"
import script from "./companyCheck3.vue?vue&type=script&lang=js"
export * from "./companyCheck3.vue?vue&type=script&lang=js"
import style0 from "./companyCheck3.vue?vue&type=style&index=0&id=b2eb1054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eb1054",
  null
  
)

export default component.exports